module.exports = __webpack_public_path__ + "img/vignette_sol.dc791b46.png";